// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"59ddacf7","453":"8cc0e317","455":"64fd9e4a","867":"9824a6e0","977":"4ec8063d"}[chunkId] + ".chunk.js";
};